import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { AcademySiteStatus } from "../../../schemas/academy-site";
import { queryKeys } from "../../query-keys";

export function useAcademySites(status?: AcademySiteStatus) {
	return useQuery({
		queryFn: () => adminApi.sites.list(status),
		queryKey: queryKeys.sites.list(status),
	});
}

export function useAcceptAcademySite() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, subdomain }: { id: string; subdomain?: string }) =>
			adminApi.sites.accept(id, subdomain),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.sites.all });
		},
	});
}

export function useRejectAcademySite() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, reason }: { id: string; reason: string }) =>
			adminApi.sites.reject(id, reason),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.sites.all });
		},
	});
}
